<template>
  <div class="index-style">
    <!-- <TopHeader></TopHeader> -->
    <div class="tac">
      <div class="left-col">
        <img class="top-icon" :src="require('$img/inner-icon.png')" alt="" />

        <el-menu
                 router
                 :default-openeds="['0']"
                 :default-active="$route.path"
                 class="el-menu-vertical"
                 @open="handleOpen"
                 @close="handleClose"
                 :collapse="isCollapse"
                 @select="handleSelect">
          <template v-for="(item, index) in menu">
            <!-- 折叠 -->
            <el-submenu :index="index + ''" :key="index" v-if="item.children">
              <template slot="title">
                <!-- <i :class="item.icon"></i> -->
                <img
                     :src="$ossUrl +
                       item.icon +
                       (activeRoute.indexOf(item.path) !== -1 ? '-active' : '') +
                       '.png'
                       "
                     width="24px"
                     height="24px"
                     alt="1" />
                <!-- <img v-if="item.title=='招聘管理'" src="../../assets/img/zpgl-active.png" width="12px" height="12px" alt=""> -->
                <span
                      class="icon-txt"
                      :class="activeRoute.indexOf(item.path) !== -1 ? 'txt-active' : ''
                        ">{{ item.title }}</span>
              </template>
              <template v-for="(data, count) in item.children">
                <el-menu-item class="item-menu" :index="data.path" :key="count">
                  <span class="inner-menu-txt">
                    {{ data.title }}
                  </span>
                </el-menu-item>
              </template>
            </el-submenu>
            <!-- 单个 -->
            <el-menu-item
                          :index="item.path"
                          :key="index"
                          v-else-if="item.hide !== true"
                          :disabled="userInfo.apply_status == 1 && item.path == '/Management/staff'
                            ? true
                            : false
                            ">
              <!-- <i :class="item.icon"></i> -->
              <img
                   :src="$ossUrl +
                     item.icon +
                     (activeRoute.indexOf(item.path) !== -1 ? '-active' : '') +
                     '.png'
                     "
                   width="24px"
                   height="24px"
                   alt="2" />
              <span
                    slot="title"
                    class="icon-txt"
                    :class="activeRoute.indexOf(item.path) !== -1 ? 'txt-active' : ''
                      ">
                {{ item.title }}

                <img v-show="item.isNew"
                     :src="$ossUrl + '3.6.0/pc3-new.png'"
                     width="17px" />
              </span>

            </el-menu-item>
          </template>
        </el-menu>

        <div class="btn-btm" v-if="userInfo.company_id > 0 && freeRight > 0">
          <div class="btm-label">
            <img class="btm-img" @click="jumpWjUrl" :src="ad" alt="" />
            <div class="number shake-slow">
              {{ freeRight > 99 ? 99 : freeRight }}
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content-header">
          <div class="subscribe">
            <label
                   v-if="userInfo.company_id > 0 && userInfo.wx_subscribe !== 1"
                   @click="openCustomer">
              为确保您能收到职位审核和简历投递提醒，请关注地产<span>同行圈公众号</span>
            </label>
          </div>

          <div class="rigth">
            <div
                 class="customer-box"
                 style="margin-right: 10px"
                 @click="openNotice">
              <i
                 class="el-icon-message-solid"
                 style="color: red; margin-right: 6px"></i>
              通知
            </div>
            <div
                 class="customer-box"
                 style="margin-right: 10px"
                 @click="openCustomer">
              <img :src="$ossUrl + '3.0.0/pc/phone.png'" alt="" />
              客服
            </div>
            <div
                 class="customer-box"
                 style="margin-right: 10px">
              <img :src="assist" alt="" />
              <a :href="pdfUrl" style="color:#3c4554" target="_blank">帮助</a>
            </div>
            <div class="customer-box" @click="openInvitation">
              <img :src="userpng" alt="" />
              邀请好友
            </div>
            <el-dropdown
                         trigger="click"
                         class="my-info-view"
                         @command="dropFunc">
              <div class="view-click">
                <img :src="userInfo.head_logo" alt="" />
                <p class="tel-num">{{ userTel }}</p>
              </div>

              <el-dropdown-menu slot="dropdown" class="dropdown-menu">
                <!-- <el-dropdown-item command='1'>我的资料</el-dropdown-item> -->
                <el-dropdown-item command="2">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <section class="content-container">
          <router-view></router-view>
        </section>
      </div>
    </div>

    <el-dialog
               :visible.sync="customerFlag"
               width="460px"
               title="客户服务"
               class="modal-kf">
      <div class="content-mod">
        <div class="mod">咨询套餐或产品使用，请联系服务顾问</div>
        <div class="mod" :style="{ marginBottom: '16px' }">
          <span class="service-name">
            {{ serviceInfo.service_name }}
            <span class="service-name-label">服务顾问</span>
          </span>
        </div>
        <div class="mod" :style="{ marginBottom: '10px' }">
          <img class="icon" :src="$ossUrl + '3.0.0/pc/wxphone.png'" alt="" />
          <div class="number">{{ serviceInfo.service_phone }}</div>
        </div>
        <div class="mod">
          <img class="icon" :src="$ossUrl + '3.0.0/pc/wxnumber.png'" alt="" />
          <span class="number">{{ serviceInfo.service_wechat_no }}</span>
        </div>
        <div class="mod-code">
          <div class="code">
            <img :src="serviceInfo.qrcode_url" alt="" />
            <div>关注微信公众号<br />即可接收简历投递等通知</div>
          </div>
          <div class="code">
            <img :src="$ossUrl + '3.0.0/pc/wxxcx.png'" alt="" />
            <div>使用微信扫码<br />访问地产同行圈小程序</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <DialogFormCustom
                      title="邀请好友"
                      :visible.sync="formDialogShow"
                      label-position="right"
                      diaWidth="500px"
                      :showFooter="false">
      <template slot="before">
        <div class="index-form-config">
          <div class="title">邀请好友使用地产同行圈招聘：</div>
          <div class="desc">复制下方链接，分享给好友即可邀请～</div>
          <div class="copy-item">
            <span>{{ `${url}/login?u=${userInfo.id}` }}</span>
            <a @click="handleConfirmCopy(`${url}/login?u=${userInfo.id}`)">复制链接</a>
          </div>
        </div>
      </template>
    </DialogFormCustom>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Menu from "@/router/Menu";
import Cookies from "js-cookie";
import ad from "$img/ad.png";
import userpng from "$img/index/user.png";
import assist from "@/assets/img/assist.png";
import DialogFormCustom from "@/components/DialogFormCustom";

export default {
  components: {
    DialogFormCustom,
  },
  data() {
    return {
      ad,
      userpng,
      assist,
      menu: Menu,
      isCollapse: false,
      customerFlag: false,
      serviceInfo: {},
      activeRoute: "",
      formDialogShow: false,
      url: process.env.VUE_APP_WEB_URL,
      pdfUrl: "https://modelwiser-linked-1256356146.piccd.myqcloud.com/%E5%9C%B0%E4%BA%A7%E5%90%8C%E8%A1%8C%E5%9C%88pc%E7%AB%AF%E6%8B%9B%E8%81%98%E5%8A%9F%E8%83%BD%E6%8C%87%E5%8D%97.pdf"
    };
  },
  computed: {
    ...mapState(["userInfo", "freeRight"]),
    userTel() {
      let tel = this.userInfo.mobile;
      return tel?.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  created() {
    const noticeVersion = 4;
    const nowNoticeVersion = localStorage.getItem("noticeVersion");
    if (!nowNoticeVersion || nowNoticeVersion < noticeVersion) {
      this.openNotice();
      localStorage.setItem("noticeVersion", noticeVersion);
    }
  },
  mounted() {
    this.activeRoute = this.$router.history.current.path;
    this.getServiceInfo();
    this.getFreeRight();
    this.$bus.$on("updateFreeRight", () => {
      this.getFreeRight();
    });
    this.$bus.$on("openCustomer", () => {
      this.openCustomer();
    });
  },
  watch: {
    $route: {
      handler(val, oldval) {
        // console.log(val);//新路由信息
        // console.log(oldval);//老路由信息
        this.activeRoute = val.path;
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["SAVA_SERVICE_INFO"]),
    ...mapActions(["freeRightUpdate"]),
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      this.activeRoute = key;
      // console.log(key, keyPath);
    },
    openCustomer() {
      this.customerFlag = true;
    },
    openInvitation() {
      this.formDialogShow = true;
    },
    openNotice() {
      this.$alert(
        `<div style="color:#59687E;">
<div style="font-size:18px;margin-bottom:20px;color:#303B4B;">亲爱的地产同行圈招聘官：</div>
<div style="width:100%;text-align: center">重要通知！！！重要通知！！！</div>
<br>地产同行圈超值福利来袭，购买套餐即可赠送购买价值10%的单品随心选！聚力、钜惠、巨划算，欢迎购买咨询！<br>
<br>可点击-招聘权益，直接线上购买，咨询请联系我们的工作人员：微信号：thq-y03</br>
地产同行圈团队<br><br>
</div>`,
        "",
        {
          confirmButtonText: "关闭",
          showClose: false,
          dangerouslyUseHTMLString: true,
          customClass: "openNotice",
          callback: () => {
            this.customerFlagLoading = false;
          },
          // center: true,
        }
      );
    },
    dropFunc(e) {
      if (e === "1") {
        this.$router.push("/info/index");
      } else {
        Cookies.remove("pc_token");
        this.$router.push("/login");
      }
    },
    getServiceInfo() {
      this.$axios.post("/recruitment/serviceInfo").then((res) => {
        this.serviceInfo = res.data.info;
        this.SAVA_SERVICE_INFO(res.data.info);
      });
    },
    getFreeRight() {
      if (this.userInfo.company_id < 1) {
        return;
      }
      this.freeRightUpdate();
    },
    jumpWjUrl() {
      this.$router.push({
        name: "Rights",
        params: {
          current: 5,
        },
      });
      // this.activeRoute = "/rights/list";
    },
    handleConfirmCopy(test) {
      this.$copyText(test).then(() => {
        this.$success("链接已复制");
      });
    },
  },
};
</script>

<style lang="scss">
@import "$styles/global.scss";

#app {
  //  background: #F9FAFB;
}

.el-dropdown-menu {
  min-width: 100px;
}

.openNotice {
  width: 840px;
}

// @keyframes shake-slow {
//   30% {
//     transform: translate(0, 0) rotate(0);
//   }
//   40% {
//     transform: translate(4px, 4px) rotate(-5deg);
//   }
//   50% {
//     transform: translate(4px, 4px) rotate(5deg);
//   }
//   60% {
//     transform: translate(0, 0) rotate(0);
//   }
// }

@keyframes shake-slow {
  48% {
    transform: translate(0, 0) rotate(0);
  }

  50% {
    transform: translate(6px, 0) rotate(0);
  }

  52% {
    transform: translate(-6px, 0) rotate(0);
  }

  55% {
    transform: translate(0, 0) rotate(0);
  }
}

.shake-slow {
  animation: shake-slow 3s infinite ease-in-out;
}

.index-style {
  width: 100%;
  min-width: 1280px;
  height: 100%;
  overflow: hidden;

  .dropdown-menu {
    min-width: 100px;
  }

  .index-form-config {
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #3c4554;
      margin-bottom: 5px;
    }

    .desc {
      font-size: 12px;
      color: #888d96;
      margin-bottom: 15px;
    }

    .copy-item {
      margin-bottom: 30px;
      @include flex-box(flex-start);

      span {
        display: block;
        width: 350px;
        height: 28px;
        line-height: 28px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #dae2ef;
        padding-left: 12px;
        margin-right: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #a9afb9;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      a {
        // margin-top: 10px;
        // display: block;
        width: 80px;
        height: 28px;
        background: #403cf0;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        padding: 5px 12px;
        cursor: pointer;
        // display: inline-block;
      }
    }
  }

  .tac {
    height: 100%;
    width: 100%;
    // @include flex-box(space-between);
    display: flex;
    flex-wrap: nowrap;

    .el-menu-item {
      color: #3c4554;
      padding: 0 20px 0 30px !important;
      height: 22px;
      line-height: 22px;
      margin-bottom: 30px;
    }

    .left-col {
      min-height: 100vh;
      box-sizing: border-box;
      padding: 30px 0;
      width: 240px;
      min-width: 240px;
      position: relative;
      flex-shrink: 1;

      .el-menu-item,
      .el-submenu__title {
        border-radius: 10px !important;
      }

      .top-icon {
        width: 139px;
        height: 28px;
        margin-bottom: 30px;
        margin-left: 30px;
      }

      .btn-btm {
        width: 200px;
        height: 194px;
        position: fixed;
        left: 20px;
        bottom: 15px;
        cursor: pointer;
        z-index: 999;

        .btm-img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 99;
        }

        .btm-label {
          position: relative;
          width: 100%;
          height: 100%;
        }

        .number {
          position: absolute;
          @include flex-box();
          width: 23px;
          height: 23px;
          background: #ff6e33;
          border-radius: 100%;
          font-size: 12px;
          font-weight: 500;
          color: #ffffff;
          z-index: 999;
          right: 10px;
          bottom: 40px;
        }
      }
    }

    .el-menu-vertical {
      border: none;
      z-index: 10;
    }

    .item-menu {
      width: 100%;
      min-width: 0;
      margin: 10px 0;

      .inner-menu-txt {
        padding-left: 15px;
      }
    }

    .icon-txt {
      margin-left: 10px;
      font-size: 14px;
      font-weight: 500;
      color: #3c4554;
      line-height: 20px;
    }

    .is-active .icon-txt {
      // background-color: $guide-color;
      // color: #4061f8;
    }

    .txt-active {
      color: #4061f8;
    }

    .el-menu-item:hover,
    .el-menu-item:focus {
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }

    >.content {
      // width: calc(100% - 280px);
      background: $all-bg-color;
      height: 100vh;
      flex: 1;
      padding-bottom: 10px;

      .content-header {
        height: 48px;
        @include flex-box(space-between);
        box-sizing: border-box;
        padding-right: 40px;

        .my-info-view {
          cursor: pointer;

          .view-click {
            @include flex-box();
          }

          img {
            width: 28px;
            height: 28px;
            border-radius: 50%;
          }

          .tel-num {
            margin-left: 10px;
            font-size: 14px;
            font-size: 14px;
            color: #3c4554;
          }
        }

        .rigth {
          @include flex-box();
        }

        .subscribe {
          cursor: pointer;
          font-weight: 400;
          color: #f4771d;
          margin-left: 10px;

          span {
            text-decoration: underline;
          }
        }

        .customer-box {
          font-size: 14px;
          color: #3c4554;
          line-height: 28px;
          margin-right: 20px;
          border-radius: 4px;
          border: 1px solid #eeeeee;
          cursor: pointer;
          padding: 0 10px;
          @include flex-box();

          &:hover {
            background: #eeeeee;
          }

          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
      }
    }
  }

  .content-container {
    height: calc(100% - 48px);
    padding: 0 10px;
    // overflow: auto;
  }

  .modal-kf {
    .el-dialog__title {
      font-size: 18px;
      font-weight: 500;
      color: #000000;
    }

    .content-mod {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
      color: #888d96;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      .mod {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
        font-size: 14px;

        .service-name {
          font-size: 18px;
          font-weight: 500;
          color: #3c4554;
          position: relative;
        }

        .service-name-label {
          position: absolute;
          font-size: 12px;
          border-radius: 4px;
          border: 1px solid #e5d9cb;
          color: #9d7953;
          padding: 0 6px;
          line-height: 20px;
          width: 70px;
          margin-left: 14px;
          top: 2px;
        }

        .icon {
          width: 15px;
          height: 15px;
          margin-right: 16px;
          vertical-align: middle;
        }

        .number {
          display: inline-block;
          min-width: 90px;
          font-size: 14px;
          color: #3c4554;
          font-weight: 400;
          text-align: left;
        }
      }

      .mod-code {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
      }

      .code {
        width: 140px;
        font-size: 12px;
        color: #3c4554;
        text-align: center;

        img {
          width: 136px;
          height: 136px;
          margin-bottom: 5px;
        }
      }

      .code:last-child {
        margin-left: 60px;
      }

      .line {
        margin: 17px 0 37px 0;
        width: 100%;
        height: 1px;
        background-color: #eee;
      }
    }
  }
}
</style>
